import type { LtPlusBillingInterval, StripeConfig } from '../../types';

export const DEFAULT_LT_PLUS_BILLING_INTERVAL: LtPlusBillingInterval = 'annual';

export const getLtPlusPlanAmount = (
  stripeConfig: StripeConfig,
  billingInterval: LtPlusBillingInterval = DEFAULT_LT_PLUS_BILLING_INTERVAL
) => {
  const configuredAmount = stripeConfig.subscriptionPlans?.[billingInterval]?.amount;

  if (typeof configuredAmount === 'number') {
    return configuredAmount;
  }

  if (billingInterval === 'annual') {
    return stripeConfig.subscriptionPrice;
  }

  return 0;
};

export const getAvailableLtPlusBillingIntervals = (
  stripeConfig: StripeConfig
): LtPlusBillingInterval[] => {
  const availableIntervals = (['annual', 'monthly'] as const).filter(
    (billingInterval) => getLtPlusPlanAmount(stripeConfig, billingInterval) > 0
  );

  return availableIntervals.length > 0
    ? [...availableIntervals]
    : [DEFAULT_LT_PLUS_BILLING_INTERVAL];
};

export const formatLtPlusCurrency = (amountInCents: number, maximumFractionDigits = 2) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: amountInCents % 100 === 0 ? 0 : 2,
    maximumFractionDigits,
  }).format(amountInCents / 100);

export const formatLtPlusPlanPrice = (
  amountInCents: number,
  billingInterval: LtPlusBillingInterval
) => `${formatLtPlusCurrency(amountInCents)}/${billingInterval === 'annual' ? 'yr' : 'mo'}`;
